export default __webpack_public_path__ + "static/media/TopBarDollarSign.8a540d09.svg";